import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { isMobile, isTablet } from "../../../@css-style";

export const ElProcess = styled.section`
  width: 100%;
  display: flex;
  /* padding: 10px; */
  position: relative;
  justify-content: space-between;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 100;
  font-style: normal;
  padding: 5em 0;
  background-attachment: fixed; /* KEY for parallax */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  ${isMobile} {
    padding: 4em 0;
  }
  * {
    font-family: "Plus Jakarta Sans", sans-serif;
  }
`;

export const ElProcessContent = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  /* gap: 15px; */
  padding: 10px;
  align-items: center;
  justify-content: space-between;
`;

export const ElColumn = styled.div<{ "data-color"?: string }>`
  width: 33.33%;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  align-items: center;
  padding: 2em;
  gap: 1em;
  /* text-align: center; */
  height: 100%;
  flex-direction: column;
  img {
    max-width: 80%;
    width: 100%;
    height: auto;
    object-fit: contain;
  }
  h3 {
    font-size: 17px;
    font-weight: 600;
    display: block;
    width: 100%;
    * {
      text-transform: uppercase;
    }
    [data-color="green"] {
      color: var(--theme-main-color);
      /* text-shadow: 0px 0px 15px rgba(255, 244.37821361058602, 233.38043478260872, 0.87); */
    }
  }

  p {
    color: #003562;

    text-align: center;
    font-family: Montserrat;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 125%; /* 30px */
    letter-spacing: -0.96px;
  }
  ${isMobile} {
    height: auto;
    width: 100% !important;
    justify-content: center;
    align-items: center;
    flex: none !important;
  }
`;

export const ElCrossLine = styled.div`
  width: 100%;
  height: 0;
  position: absolute;
  left: 0;
  top: 60px;
  border-bottom: 3px dashed rgba(67, 124, 187, 0.39);
  background-color: transparent;
  border-radius: 0;
`;

export const ElDotCircle = styled.div`
  width: 60px;
  height: 60px;
  flex-shrink: 0;
  background-color: #437cbb;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  font-weight: 700;
  color: #fff;
`;

export const elGapProcess = css`
  gap: 20px;
  position: relative !important;
  z-index: 2 !important;
`;

export const elBgWhite = css`
  /* background-color: #fff;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.18);
  border-radius: 10px; */
`;
